import React from 'react';
import {NavLink} from 'react-router-dom';

function Footer() {
  return (
    <footer className='mt-6 w-full flex flex-col justify-center h-footer-height overflow-hidden bg-white'>
        <div className='w-full flex flex-col justify-center h-footer-height overflow-hidden bg-footer'>
            <div className='flex justify-center w-full h-auto mt-60'>
                <span className='w-line-footer-width border border-white'></span>
            </div>

            <div className='flex justify-center w-full h-56'>

                <div className='w-full h-full flex flex-row px-4 max-w-6xl justify-center'>

                    <div className='hidden w-1/2 h-auto sm:flex sm:flex-col'>
                        <div className='relative z-10'>
                            <div className='absolute top-0 left-0 mt-4 ml-4'>
                                <div>
                                    <h2 className='text-lg text-white font-bold'>Síguenos</h2>
                                </div>

                                <div>
                                    <a className='w-52 mt-3 flex flex-row items-center hover:scale-105' href="https://www.facebook.com/laboratoriosantabarbara?mibextid=LQQJ4d">
                                    <img className='w-10 h-10' src="/images/facebook.svg" alt="Facebook"/>
                                    <p className='text-base text-white font-normal ml-2'>Facebook</p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='w-1/2 h-auto flex flex-col'>
                        <div className='relative z-20'>
                            <div className='absolute top-0 left-0 mt-4 ml-4'>
                                <div>
                                    <h2 className='text-lg text-white font-bold'>Contactos</h2>
                                </div>

                                <div>
                                    <a className='w-52 mt-3 flex flex-row items-center hover:scale-105' href="https://wa.link/dnhyck">
                                    <img className='w-9 h-9' src="/images/whatsapp.svg" alt="Whatsapp"/>
                                    <p className='text-base text-white font-normal ml-2'>8976 3172</p>
                                    </a>
                                </div>
                                
                                <div>
                                    <a className='w-52 mt-3 flex flex-row items-center hover:scale-105' href="tel:22699990">
                                    <img className='w-9 h-9' src="/images/phone.svg" alt="Phone"/>
                                    <p className='text-base text-white font-normal ml-2'>2269 9990</p>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='hidden w-1/2 h-auto lg:flex lg:flex-col'>
                        <div className='relative z-10'>
                            <div className='absolute top-0 left-0 mt-4 ml-4'>
                                <div>
                                    <h2 className='text-lg text-white font-bold mb-3'>Enlaces</h2>
                                </div>
                                
                                <div>
                                    <NavLink to="/" className='w-52 mt-3 items-center text-white font-normal hover:font-semibold'>Inicio</NavLink>
                                </div>
                                
                                <div>
                                    <NavLink to="/AboutUs" className='w-52 mt-0 items-center text-white font-normal hover:font-semibold'>Nosotros</NavLink>
                                </div>

                                <div>
                                    <NavLink to="/Services" className='w-52 mt-0 items-center text-white font-normal hover:font-semibold'>Servicios</NavLink>
                                </div>

                                <div>
                                    <NavLink to="/News" className='w-52 mt-0 items-center text-white font-normal hover:font-semibold'>Noticias</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='w-1/2 h-auto flex flex-col'>
                        <div className='relative z-10'>
                            <div className='absolute top-0 left-0 mt-4 ml-4'>
                                <div>
                                    <h2 className='text-lg text-white font-bold'>Políticas</h2>
                                </div>
                                
                                <div>
                                    <a className='w-52 mt-3 flex flex-row items-center text-white font-normal hover:font-semibold' href="https://firebase.google.com/support/privacy?hl=es-419">Políticas de Privacidad</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='w-full flex'>
                <span className='h-5 w-full text-slate-500 bg-white border border-white text-center text-sm'>Laboratorio Santa Bárbara ©, Derechos Reservados</span>
            </div>
        </div>
    </footer>
  )
}

export default Footer
